import { render, staticRenderFns } from "./UtilWarningStaging.vue?vue&type=template&id=cbec7cec"
import script from "./UtilWarningStaging.vue?vue&type=script&lang=js"
export * from "./UtilWarningStaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports